// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__36oGo","selects":"Documents_selects__1P6kG"};